import { useState } from "react";

import { useQuery } from "@tanstack/react-query";

import { AssignmentStatus, assignmentsApi } from "@/api";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { QueryKey } from "@/query/Query";

export function useAssignments() {
  const { currentUser } = useCurrentUserContext();
  const [selectedCounselorId, setSelectedCounselorId] = useState<string | null>(currentUser.counselorId ?? "");

  const isOverdue = true;

  const { data: assignments = [] } = useQuery({
    queryKey: [QueryKey.Assignments, selectedCounselorId, AssignmentStatus.Open, isOverdue],
    queryFn: () =>
      assignmentsApi.getAllAssignments({
        assignedCounselorId: selectedCounselorId ?? undefined,
        status: AssignmentStatus.Open,
        onlyOverdue: isOverdue,
      }),
  });

  const onCounselorChange = (counselorId: string | null) => {
    setSelectedCounselorId(counselorId);
  };

  return {
    assignments,
    selectedCounselorId,
    onCounselorChange,
  };
}
